import { createContext, useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { userDetailQuery } from '../utils/masterData';

const initialUserContextState = {
  user: undefined,
  loading: true,
  error: false,
  refresh: () => null,
  hasAccessToMainInfo: false,
  hasLoadsPageAccess: false,
  canCreatePTJob: false,
};

export const userContext = createContext(initialUserContextState);

export const UserContextProvider = ({ children }) => {
  const { data: user, isLoading: loading, error, refetch: refresh } = useQuery(userDetailQuery);

  const hasAccessToMainInfo =
    user?.isCAM || user?.isPTEngineer || user?.isPTScheduler || user?.isPTDispatcher || user?.isAdmin;
  const hasLoadsPageAccess = user?.isPTProjectManager || user?.isPTDetailer;
  const canCreatePTJob = user?.isCAM;

  const value = useMemo(
    () => ({ error, loading, refresh, user, hasAccessToMainInfo, hasLoadsPageAccess, canCreatePTJob }),
    [error, loading, refresh, user, hasAccessToMainInfo, hasLoadsPageAccess, canCreatePTJob]
  );
  return <userContext.Provider value={value}>{children}</userContext.Provider>;
};

export const useUserContext = () => {
  const context = useContext(userContext);

  return context;
};
